import { createContext } from 'react';

/**
 * The socket's state, shared without anybody importing a socket.
 *
 * In its own module so `RealtimeProvider.jsx` exports a component and nothing
 * else, which is what keeps fast refresh working during development.
 */
export const RealtimeContext = createContext({
  connected: false,
  typing: {},
  sendTyping: () => {},
});
